// import React from 'react'

// const RefreshBtn = () => {
//   return (
//    <svg width="40" height="40" viewBox="0 0 40 40" fill="currentcolor" xmlns="http://www.w3.org/2000/svg">
//    <path 
//      d="M32.7496 18.5853C32.3739 18.5853 32.0136 18.7346 31.7479 19.0002C31.4822 19.2659 31.333 19.6263 31.333 20.002C31.3498 22.6554 30.4409 25.2317 28.7627 27.2871C27.0844 29.3425 24.742 30.7483 22.1388 31.2625C19.5355 31.7766 16.8345 31.3669 14.5009 30.1039C12.1672 28.8409 10.3471 26.8036 9.35388 24.343C8.36068 21.8824 8.25663 19.1524 9.05963 16.6233C9.86264 14.0942 11.5224 11.9243 13.7532 10.4873C15.9839 9.05034 18.6459 8.4362 21.2807 8.7507C23.9155 9.06519 26.3582 10.2886 28.188 12.2103H24.788C24.4123 12.2103 24.0519 12.3596 23.7863 12.6252C23.5206 12.8909 23.3713 13.2513 23.3713 13.627C23.3713 14.0027 23.5206 14.363 23.7863 14.6287C24.0519 14.8944 24.4123 15.0436 24.788 15.0436H31.2055C31.5812 15.0436 31.9415 14.8944 32.2072 14.6287C32.4729 14.363 32.6221 14.0027 32.6221 13.627V7.25199C32.6221 6.87627 32.4729 6.51593 32.2072 6.25026C31.9415 5.98458 31.5812 5.83533 31.2055 5.83533C30.8298 5.83533 30.4694 5.98458 30.2037 6.25026C29.9381 6.51593 29.7888 6.87627 29.7888 7.25199V9.75949C27.4296 7.50424 24.364 6.13276 21.1103 5.87688C17.8566 5.62099 14.6144 6.49641 11.9316 8.35513C9.24889 10.2139 7.29021 12.9419 6.38668 16.0781C5.48316 19.2143 5.69023 22.5662 6.97287 25.5674C8.25552 28.5685 10.5351 31.0347 13.4262 32.5492C16.3173 34.0636 19.6427 34.5333 22.8401 33.8789C26.0376 33.2245 28.911 31.4861 30.9748 28.9577C33.0385 26.4292 34.1658 23.2657 34.1663 20.002C34.1663 19.6263 34.0171 19.2659 33.7514 19.0002C33.4857 18.7346 33.1254 18.5853 32.7496 18.5853Z" 
//      fill="currentcolor"
//    />
//  </svg>
//   )
// }

// export default RefreshBtn


import React from 'react'

const RefreshBtn = ({disabled=false}) => {
//   return disabled? (
// <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
// <g>
// <rect x="2" y="1" width="40" height="40" rx="16" fill="#EBEBED"/>
// <path d="M29.9329 22.0407C29.7441 23.4806 29.1669 24.842 28.2631 25.9788C27.3594 27.1157 26.1632 27.985 24.8029 28.4937C23.4426 29.0024 21.9695 29.1312 20.5416 28.8663C19.1137 28.6013 17.7848 27.9527 16.6975 26.99C15.6102 26.0272 14.8055 24.7867 14.3696 23.4013C13.9338 22.016 13.8833 20.5381 14.2235 19.1263C14.5637 17.7144 15.2819 16.4218 16.3009 15.387C17.32 14.3523 18.6014 13.6145 20.0079 13.2527C23.9069 12.2527 27.9429 14.2597 29.4329 17.9997" stroke="#F6F6F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// <path d="M30 13V18H25" stroke="#F6F6F6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
// </g>
// <defs>
// <filter id="filter0_dd_411_28321" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
// <feFlood flood-opacity="0" result="BackgroundImageFix"/>
// <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
// <feOffset dy="1"/>
// <feGaussianBlur stdDeviation="1"/>
// <feColorMatrix type="matrix" values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"/>
// <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_28321"/>
// <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
// <feOffset/>
// <feGaussianBlur stdDeviation="0.5"/>
// <feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"/>
// <feBlend mode="normal" in2="effect1_dropShadow_411_28321" result="effect2_dropShadow_411_28321"/>
// <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_28321" result="shape"/>
// </filter>
// </defs>
// </svg>

//   ):
 return (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
<g>
<rect x="2" y="1" width="40" height="40" rx="16" fill="white"/>
<path d="M29.9331 22.0407C29.7442 23.4806 29.167 24.842 28.2632 25.9788C27.3595 27.1157 26.1633 27.985 24.803 28.4937C23.4427 29.0024 21.9696 29.1312 20.5417 28.8663C19.1138 28.6013 17.7849 27.9527 16.6976 26.99C15.6103 26.0272 14.8056 24.7867 14.3697 23.4013C13.9339 22.016 13.8834 20.5381 14.2236 19.1263C14.5639 17.7144 15.282 16.4218 16.301 15.387C17.3201 14.3523 18.6016 13.6145 20.0081 13.2527C23.9071 12.2527 27.9431 14.2597 29.4331 17.9997" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M30 13V18H25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_dd_411_28996" x="0" y="0" width="44" height="44" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="1"/>
<feGaussianBlur stdDeviation="1"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.356863 0 0 0 0 0.407843 0 0 0 0 0.443137 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_411_28996"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset/>
<feGaussianBlur stdDeviation="0.5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0.101961 0 0 0 0 0.12549 0 0 0 0 0.141176 0 0 0 0.32 0"/>
<feBlend mode="normal" in2="effect1_dropShadow_411_28996" result="effect2_dropShadow_411_28996"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_411_28996" result="shape"/>
</filter>
</defs>
</svg>

  )
}

export default RefreshBtn
